/**
 * Small building blocks every chart kind of the AVA Assistant chart engine shares: the data
 * palette, the width rule and number rounding. A leaf module (it imports nothing), so
 * chartEngine.js and timelineGeometry.js can both use it without importing each other.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */

/** Astryx categorical data colours a series (or a timeline state) may use. */
export const SERIES_COLORS = Object.freeze(['blue', 'orange', 'purple', 'teal']);

export const DEFAULT_COLOR = 'blue';
const DEFAULT_WIDTH = 360;
const MIN_WIDTH = 200;

export const ELLIPSIS = '…';

/** The CSS colour for a palette name; anything outside the palette falls back to blue. */
export const dataColor = (name) => `var(--color-data-${SERIES_COLORS.includes(name) ? name : DEFAULT_COLOR})`;

/** The chart's real pixel width, never below the minimum, so text keeps its design size. */
export const widthOf = (w) => Math.max(MIN_WIDTH, Math.round(Number(w) || DEFAULT_WIDTH));

/** Rounds to one decimal, which keeps SVG attributes short. */
export const fixed = (n) => Math.round(n * 10) / 10;
